export enum CheckLogTimeType {
  MAIN = 1,
  ADDITIONAL = 2,
  SESSION = 3,
}
